(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('plan-de-estudios', {
            parent: 'entity',
            url: '/plan-de-estudios',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'PlanDeEstudios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios.html',
                    controller: 'PlanDeEstudiosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('plan-de-estudios-detail', {
            parent: 'plan-de-estudios',
            url: '/plan-de-estudios/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'PlanDeEstudios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-detail.html',
                    controller: 'PlanDeEstudiosDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PlanDeEstudios', function($stateParams, PlanDeEstudios) {
                    return PlanDeEstudios.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'plan-de-estudios',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('plan-de-estudios-detail.edit', {
            parent: 'plan-de-estudios-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-dialog.html',
                    controller: 'PlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlanDeEstudios', function(PlanDeEstudios) {
                            return PlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plan-de-estudios.new', {
            parent: 'plan-de-estudios',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-dialog.html',
                    controller: 'PlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('plan-de-estudios', null, { reload: 'plan-de-estudios' });
                }, function() {
                    $state.go('plan-de-estudios');
                });
            }]
        })
        .state('plan-de-estudios.edit', {
            parent: 'plan-de-estudios',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-dialog.html',
                    controller: 'PlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlanDeEstudios', function(PlanDeEstudios) {
                            return PlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plan-de-estudios', null, { reload: 'plan-de-estudios' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plan-de-estudios.delete', {
            parent: 'plan-de-estudios',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plan-de-estudios/plan-de-estudios-delete-dialog.html',
                    controller: 'PlanDeEstudiosDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PlanDeEstudios', function(PlanDeEstudios) {
                            return PlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plan-de-estudios', null, { reload: 'plan-de-estudios' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
